import { Alert, Box, Text } from '@nimbus-ds/components';
import { dateFormat, Format } from 'commons/utils/date';
import useGetPlanDebt from 'domains/Auth/hooks/useGetPlanDebt';
import { useExpirationDate } from 'domains/Billing/Checkout/hooks';
import useTranslationBilling from 'domains/Billing/useTranslationBilling';
import { PaymentStatusAlertProps } from '../../PaymentStatusAlert';
import { PayButton } from '../PayButton';

export default function PaymentStatusAlertPending({
  concept,
  isExternalContext,
  externalReference,
  showPaymentButton = false,
}: Readonly<PaymentStatusAlertProps>) {
  const t = useTranslationBilling('checkout.paymentStatusAlert.pending');
  const { expirationDate, appName } = useExpirationDate(
    concept,
    externalReference || undefined,
  );
  const { planDebtData, shouldUseDebtData } = useGetPlanDebt();

  if (!expirationDate || isExternalContext) return null;

  if (concept === 'plan-cost') {
    const closeToExpiration =
      shouldUseDebtData &&
      !!planDebtData?.storeDownDate &&
      !!planDebtData?.adminDownDate &&
      new Date(planDebtData.adminDownDate) < new Date();

    return (
      <Alert
        appearance={closeToExpiration ? 'danger' : 'warning'}
        title={t('plan.title')}
      >
        <Box display="flex" flexDirection="column" gap="2">
          <Text>
            {closeToExpiration && planDebtData.storeDownDate
              ? t('plan.messageAdminDown', {
                  date: dateFormat(
                    planDebtData.storeDownDate,
                    Format.DD_MM,
                    'UTC',
                  ),
                })
              : planDebtData?.adminDownDate &&
                t('plan.message', {
                  date: dateFormat(
                    planDebtData.adminDownDate,
                    Format.DD_MM_YYYY,
                    'UTC',
                  ),
                })}
          </Text>
          {showPaymentButton && (
            <PayButton
              concept={concept}
              externalReference={externalReference}
            />
          )}
        </Box>
      </Alert>
    );
  }
  if (concept === 'app-cost') {
    return (
      <Alert appearance="warning">
        <Box display="flex" flexDirection="column" gap="2">
          <Text>
            {t('apps.message', {
              date: dateFormat(
                expirationDate.toISOString(),
                Format.DAY_MONTH_LONG,
              ),
              appName,
            })}
          </Text>
          {showPaymentButton && (
            <PayButton
              concept={concept}
              externalReference={externalReference}
            />
          )}
        </Box>
      </Alert>
    );
  }

  return null;
}
